import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import {bindActionCreators} from "redux";
import {loginAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Image from "material-ui-image";
import {Link} from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import ContactUs from "./ContactUs";
import * as MainConstants from "../../utils/MainConstants";




const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)
    
});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    dividerColorPurpole: {
        //marginTop: theme.spacing.unit * 3,
        height: '20px',
        color:"#ffffff",
        //backgroundColor:"#760eb3",
    },
});


class SaveTime extends Component {
    
    state = {
        age: '',
        name: 'hai',
    };
    
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    constructor(props) {
        super(props);
        this.towAgentClick = this.towAgentClick.bind(this);
        this.vehicleOwnerClick = this.vehicleOwnerClick.bind(this);
    }
    
    
    towAgentClick(){
        let { loginAction } = this.props;
        //this.props.auth.login();
        loginAction();
        //this.props.towAgentConfigCall();
        
    }
    
    vehicleOwnerClick(){
        let { loginAction } = this.props;
        //this.props.auth.login();
        loginAction();
        //this.props.vehicleOwnerConfigCall();
        
    }
    
    
    //Original pictuer was IMG_2924.JPG
    render() {
        const { classes, theme } = this.props;
        window.scrollTo(0, 0);
        return (
          <div   style={{ backgroundColor:"#F2F6F8"}} >
              
              <Grid container spacing={24}>
                  <Grid   item xs={12} sm={12}  md={8} lg={8} >
                      <div  style={{ marginLeft:10, marginTop:30}}>
                          
                          
                          <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                              {MainConstants.APPLICATION_NAME}&trade;
                          </Typography>
                          <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Tow Company
                          </Typography>
                          <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#e2580d' }} >
                              ________________
                          </Typography>
                          
                          
                          <Typography component="h4" variant="h5"     style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                              {/*<Text>As a tow truck agent or driver, you can avoid towing vehicles to your garage by using the {MainConstants.APPLICATION_NAME}&trade; app to process the violation/towing fees on the spot, and notifying the vehicle owner to move the vehicle.
                                  You can use this app for Parking Violation and Private Property Impounds tows. You can also manage all your private property communications with property and vehicle owners.</Text>*/}
                              As a tow truck agent or driver, you can use the {MainConstants.APPLICATION_NAME}&trade; app to notify vehicle owners and process towing fees on-site,
                              eliminating the need to tow vehicles to your garage. The app supports both Public Parking Violation and Private Property Impound tows, and
                              also enables you to manage all communications with property and vehicle owners in one secure platform.
                          </Typography>
                          
                          <Typography variant="h5" component="h2"     style = { {  color:'#BF360C'   }}>
                              Benefits:
                          </Typography>
                          
                          <Typography  variant="subtitle1">
                              <ul>
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Time - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Avoid unnecessary tows to your storage lot by resolving violations on-site.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Money - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Fewer trips mean less fuel consumption and reduced wear and tear on your tow trucks.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Faster Processing - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Handle multiple vehicles at once by notifying owners and collecting violation/towing
                                          fees on the spot—no need for repeated back-and-forth trips.</span> </li>
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Prevent Damage - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reducing the number of tows lowers the risk of vehicle damage.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Lower Insurance Costs - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Minimize liability and operator safety risks, helping to reduce your insurance premiums.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Environmental Impact - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Fewer truck trips mean fewer emissions and a greener operation.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20,  color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20,  color:'#e2580d'}} > Dispatching - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Use {MainConstants.APPLICATION_NAME}&trade; built-in dispatch features to assign, accept, and track tow jobs in real time.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Notifications - </span>
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>With {MainConstants.APPLICATION_NAME}&trade; Easily notify all relevant parties (e.g., police departments, property owners) through calls, emails, or faxes—directly from the platform.</span> </li>
                                  
                                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d' }}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Mobile App Access - </span>
                                      
                                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' }}> Communicate with the {MainConstants.APPLICATION_NAME}&trade; system through the TowWatch TA (Tow Agent) mobile app for seamless, on-the-go operations.
                                      
                                      <div style={{display: 'flex', flexWrap: 'wrap' }}>
                                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                          <Image
                                            //src="/static/images/IMG_3615.JPG"
                                            src="/static/images/TowWatchTAMobileB.png"
                                            aspectRatio='(3/6)'
                                          />
                                      </div>
                                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                       
                                       <Image
                                         //src="/static/images/IMG_3615.JPG"
                                         src="/static/images/TowWatchTAMobileB_1.png"
                                         aspectRatio='(3/6)'
                                       />
                                      </div>
                                          {/*}
                                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                       
                                       <Image
                                         //src="/static/images/IMG_3615.JPG"
                                         src="/static/images/TowWatchTAMobileB_2.png"
                                         aspectRatio='(3/6)'
                                       />
                                      </div>
                                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                       
                                       <Image
                                         //src="/static/images/IMG_3615.JPG"
                                         src="/static/images/TowWatchTAMobileB_3.png"
                                         aspectRatio='(3/6)'
                                       />
                                      </div>
                                      */}
                                      
                                      </div>
                                      </span>
                                  </li>
                              
                              </ul>
                          </Typography>
                          <a href="/home"  rel="noreferrer">
                              <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                                  &lArr; TowWatch Home
                              </Typography>
                          </a>
                          
                          {/*}
                                      <Card className={classes.card} display="inline-block"  style = { {backgroundColor:'#f4f3ed', color:'red', borderRadius:0, width:"100%"}}>
                                    <CardContent>

                                        <Typography variant="h5" component="h2"  style = { {  color:'#BF360C' }}>
                                            Benefits:
                                        </Typography>

                                        <Typography  variant="subtitle1">
                                            <ul>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Time - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> By not towing a vehicle to your storage lot</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Money - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> When you reduce the trips to your lot, you save gas and reduce your truck's wear and tear</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Prevent Damage - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Any time a vehicle gets towed, it increases the possibility of being damaged</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save on Insurance - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Reduce damage possibility, reduce your liability and dealing with an insruance company</span> </li>

                                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Environment - </span>
                                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reducing the trips to and from your lot, reduces the toxic gas emissions</span> </li>
                                        </ul>
                                        </Typography>
                                    </CardContent>
                                            
                                            <CardActions>
                                                    <div style = { { paddingLeft:50 }}>
        
        
                                                            <Button size="large"  variant="contained"  className={classes.button}  onClick={this.towAgentClick} style = { {textTransform:'none', backgroundColor:'white',fontSize:16, color:'red'}} >Tow Agent Sign Up</Button>
        
                                                          
                                                    </div>
                                            </CardActions>
                                        </Card>  */}
                          {/*
                                                            <Button size="big"  variant="contained"  className={classes.button} onClick={this.vehicleOwnerClick}  style = { { backgroundColor:'white',fontSize:16, color:'red'}}  href="#basic-tabs" >Vehicle Owner Sign Up </Button>
        
                                                                                            <Button variant="contained"  className={classes.button} size="big"  href="#aboutplatewiz" style = { { marginLeft:40, fontSize:20,  backgroundColor:'white', color:'black', borderSize:'2',borderRadius:'0', bordered:'true', borderColor:'black'}} >How it works</Button>
                                                                                                */}
                          {/*}  I removed teh back to top bottom
                                                        <Button variant="contained"  className={classes.button} size="large"  href="#aboutplatewiz" style = { { marginLeft:380, fontSize:16,  backgroundColor:'white', color:'black', borderSize:'2',borderRadius:'2', bordered:'true', borderColor:'black'}} >Back to top</Button>
                                                            */}
                      </div>
                  </Grid>
                  <Grid   item xs={12} sm={12}  md={4} lg={4}   >
                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10, marginBotton:10}}>
                          <Image
                            //src="/static/images/IMG_3652_B.JPG"
                            src="/static/images/1000.jpeg"
                            aspectRatio='(9/6)'
                          />
                      </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                      <Divider className={classes.dividerColorPurpole}></Divider>
                      <div  style={{ backgroundColor:"#f4f3ed"  }}>
                          <ContactUs> </ContactUs>
                      </div>
                  </Grid>
              
              </Grid>
          </div>
        
        
        );
    }
}

const mapStateToProps = (state) => {
    return {
    
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loginAction:loginAction,
        
        
    }, dispatch);
};


SaveTime.propTypes = {
    classes: PropTypes.object.isRequired,
};
//export default BiomassView;
//export default withStyles(styles, { withTheme: true })(SaveTime);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveTime));
